import { createAction, createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const biShiftsBySiteRequest = createRequest(constants.biShiftsBySite);
export const biShiftsBySiteSuccess = createSuccess(constants.biShiftsBySite);
export const biShiftsBySiteFailure = createFailure(constants.biShiftsBySite);

export const requestBIShiftsBySite = biShiftsBySiteRequest;

export const biShiftsByEmployeeRequest = createRequest(constants.biShiftsByEmployee);
export const biShiftsByEmployeeSuccess = createSuccess(constants.biShiftsByEmployee);
export const biShiftsByEmployeeFailure = createFailure(constants.biShiftsByEmployee);

export const requestBIShiftsByEmployee = biShiftsByEmployeeRequest;

export const biShiftsByMobilePatrolRequest = createRequest(constants.biShiftsByMobilePatrol);
export const biShiftsByMobilePatrolSuccess = createSuccess(constants.biShiftsByMobilePatrol);
export const biShiftsByMobilePatrolFailure = createFailure(constants.biShiftsByMobilePatrol);

export const requestBIShiftsByMobilePatrol = biShiftsByMobilePatrolRequest;

export const biShiftsDetailedRequest = createRequest(constants.biShiftsDetailed);
export const biShiftsDetailedSuccess = createSuccess(constants.biShiftsDetailed);
export const biShiftsDetailedFailure = createFailure(constants.biShiftsDetailed);

export const requestBIShiftsDetailed = biShiftsDetailedRequest;

export const setLoadingState = createAction(constants.setLoadingState);
